import { FunctionComponent } from 'react';
import { CircularProgress } from '@material-ui/core';
import ActualityAdditionalArgs from '../../../Types/Interface/TableInterfaces/AdditionalArgsInterface/ActualityAdditionalArgs';
import { ActualityInterface } from '../../../Types/Interface/TableInterfaces/DataInterface/DataInterface';
import ActualitySharedData from '../../../Types/Interface/TableInterfaces/SharedDataInterface/ActualitySharedData';
import GetActualityHighLight from '../../../Methods/TableQuery/GetSharedData/GetActualityHighLight';
import GetActualityComparatorFromKey from '../../../Methods/TableQuery/HandleFilter/HandleSort/GetActualityComparatorFromKey';
import AdminListContainer from '../BeecomingCompenents/AdminContainers/AdminListContainer';
import AdminProtection from '../BeecomingCompenents/AdminContainers/AdminProtection';
import ListHeaderActuality from '../BeecomingCompenents/ListElements/ListHeaders/ListHeaderActuality';
import ListItemActuality from '../BeecomingCompenents/ListElements/ListItems/ListItemActuality';
import AdminPageComponent from '../../../Types/Interface/ComponentInterface/AdminPageComponent';
import ApiFetch from '../../../Methods/RefreshToken/ApiRequest';
import GetActualityAdditionalQuery, {
  parseActualityList,
} from '../../../Methods/TableQuery/GetAdditionalQueries/GetActualityAdditionalQuery';
import { ActualityFormatter } from '../../../Types/Interface/TableInterfaces/DataInterface/ActualityInterface';
import { useReload } from '../../../Methods/useReload';

interface Props {}

const getActualityList = (additionalParameters: ActualityAdditionalArgs, history: any) => {
  const query = GetActualityAdditionalQuery(additionalParameters);
  return ApiFetch(`/OpenData/record/actualites/admin?${query ?? ''}`, 'GET', history);
};

const ListActuality: AdminPageComponent = ({ onError }) => {
  const [reload, reloading] = useReload();

  window.addEventListener('onReload', reload);

  if (reloading) {
    return <CircularProgress style={{ position: 'absolute' }} />;
  }
  return (
    <AdminListContainer<ActualityInterface, ActualityAdditionalArgs, ActualitySharedData>
      defaultSharedData={{ highlight: '' }}
      defaultAdditionalArgs={{ title: '', body: '', start: null, end: null }}
      defaultSort="published"
      defaultOrderType="desc"
      headComponent={ListHeaderActuality}
      listComponent={ListItemActuality}
      getList={{
        request: getActualityList,
        formatter: ActualityFormatter,
        filter: parseActualityList,
        errorMessage: "La liste des actualités n'a pas pu être chargée correctement",
      }}
      getDefaultSharedData={GetActualityHighLight}
      getComparatorFromKey={GetActualityComparatorFromKey}
      onError={onError}
    />
  );
};

const ListActualityProtected: FunctionComponent<Props> = () => (
  <AdminProtection
    title="Actualités"
    menuPath="actuality"
    screenName="actuality"
    adminPage={ListActuality}
  />
);
export default ListActualityProtected;
